export default __webpack_public_path__ + "static/combo-5f62892446495549ddb7d9a8aa668291.png";